"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const EtudeError_1 = require("../error/EtudeError");
const EtudeParser_1 = require("../util/EtudeParser");
const Pitch_1 = require("./Pitch");
const Value_1 = require("./Value");
class Note {
    constructor(pitch, value) {
        this.pitch = pitch;
        this.value = value;
    }
    apply(keySignature) {
        const pitch = this.pitch.apply(keySignature);
        if (this.pitch === pitch) {
            return this;
        }
        return new Note(pitch, this.value);
    }
    static fromString(noteString) {
        return EtudeParser_1.default
            .of(noteString)
            .filter(o => o != null, EtudeError_1.default.forNull(Note))
            .map(s => s.split("["))
            .filter(s => s.length >= 2, EtudeError_1.default.forInvalid(Note, noteString, "missing information"))
            .filter(s => s.length <= 2, EtudeError_1.default.forInvalid(Note, noteString, "contains extra information"))
            .filter(s => s[0].trim().length !== 0 && s[1].trim().length !== 0, EtudeError_1.default.forInvalid(Note, noteString, "missing information"))
            .filter(s => s[1].includes("]"), EtudeError_1.default.forInvalid(Note, noteString, "missing closing bracket"))
            .filter(s => s[1].endsWith("]"), EtudeError_1.default.forInvalid(Note, noteString, "contains extra information"))
            .parse(s => Pitch_1.default.fromString(s[0]))
            .parse(s => Value_1.default.fromString(s[1].substring(0, s[1].length - 1)))
            .get(a => new Note(a[0], a[1]));
    }
    toString() {
        return this.pitch + "[" + this.value + "]";
    }
    equals(other) {
        if (!(other instanceof Note)) {
            return false;
        }
        if (other === this) {
            return true;
        }
        let otherNote = other;
        return this.pitch.equals(otherNote.getPitch()) && this.value === otherNote.getValue();
    }
    getPitch() {
        return this.pitch;
    }
    getValue() {
        return this.value;
    }
}
exports.default = Note;
